import { render } from "./FormattingCard.vue?vue&type=template&id=26a9a7f8&scoped=true&ts=true"
import script from "./FormattingCard.vue?vue&type=script&lang=ts"
export * from "./FormattingCard.vue?vue&type=script&lang=ts"

import "./FormattingCard.vue?vue&type=style&index=0&id=26a9a7f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a9a7f8"]])

export default __exports__